export type ContactCopy = {
  readonly heading: string;
  readonly body: string;
  readonly emailLabel: string;
  readonly messageLabel: string;
  readonly sendLabel: string;
  readonly sendingLabel: string;
  readonly sentMessage: string;
  readonly errorMessage: string;
};

/**
 * One venue per entry, rendered as an aligned three-column row on the home
 * page. All three fields interpolate as raw HTML, same contract as
 * `homeBlurbs` — escape a bare `&` or `<`.
 */
export type Credential = {
  readonly venue: string;
  readonly location: string;
  readonly work: string;
};

/**
 * Short blurbs under the hero; one element per rendered line. Order is display
 * order. Interpolated as raw HTML, so inline markup works — same contract as
 * `Project.description`.
 */
export const homeBlurbs: readonly string[] = [
  'IEDLabs is my solo professional persona.',
  'I also recently co-founded a new creative studio: <a href="https://vrmln.co" target="_blank" rel="noopener noreferrer">VRMLN</a>',
];

export const credentialsIntro = 'With over 14 years of experience, I have worked on projects such as:';

export const credentials: readonly Credential[] = [
  {
    venue: 'Royal Academy of Art',
    location: 'London, England',
    work: 'temporary VR exhibition',
  },
  {
    venue: 'Universal Studios',
    location: 'Osaka, Japan',
    work: 'permanent theme park install',
  },
  {
    venue: 'MIT Museum',
    location: 'Cambridge, MA USA',
    work: 'permanent museum exhibit',
  },
  {
    venue: 'Ampex Headquarters',
    location: 'San Carlos, CA USA',
    work: 'permanent outdoor audio reactive installation',
  },
  {
    venue: 'Adler Planetarium',
    location: 'Chicago, IL USA',
    work: 'permanent museum exhibit',
  },
  {
    venue: 'Shedd Aquarium',
    location: 'Chicago, IL USA',
    work: 'long term museum exhibit',
  },
  {
    venue: 'PAX Prime / East',
    location: 'Seattle, WA / Boston, MA USA',
    work: 'interactive event installation',
  },
  {
    venue: "Staten Island Children's Museum",
    location: 'Staten Island, NY USA',
    work: 'permanent museum exhibit',
  },
];

export const contact: ContactCopy = {
  heading: 'The Socials etc.',
  body: 'Say Something Nice',
  emailLabel: 'your email address',
  messageLabel: 'human-sounding bleeps and bloops',
  sendLabel: 'Send',
  sendingLabel: 'Sending…',
  sentMessage: 'Transmission received.',
  errorMessage: 'Hmm, the internet seems to be borked. Please try again later.',
};
